import React from 'react'
import clsx from 'clsx'
import { v4 as uuid } from 'uuid'

import './Checkbox.scss'

export type TPropsCheckbox = {
  label?: string
  infoText?: string
  parentStyle?: React.CSSProperties
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

const Checkbox = (props: TPropsCheckbox) => {
  const { label, infoText, id: idProp, className, ...rest } = props

  // Ensure we always have a stable ID to associate label and description
  const reactId = uuid()
  const id = idProp || `tq-checkbox-${reactId}`

  // Merge any provided aria-describedby with our own info text id
  const infoId = infoText ? `${id}-info` : undefined
  const ariaDescribedBy = clsx(rest['aria-describedby'], infoId) || undefined

  return (
    <div className={clsx('tq-checkbox-wrapper', className)} style={props.parentStyle}>
      <div className="tq-checkbox-field">
        <input id={id} type="checkbox" className="tq-checkbox" aria-describedby={ariaDescribedBy} {...rest} />
        {label && (
          <label className="tq-checkbox-label" htmlFor={id}>
            {label}
          </label>
        )}
      </div>
      {infoText && (
        <div id={infoId} className="tq-checkbox-info">
          {infoText}
        </div>
      )}
    </div>
  )
}

export default Checkbox
